import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG, Category,
} from '../api/models';
import { ConfiguratorContext } from '../context';


interface CategoryProps {
}

export const useCategories = (props?: CategoryProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props?:CategoryProps  ) : Promise<Category[] | undefined> => {

    //const { quoteId, revision } = props;
    //if (!revision) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.getCategories();
      cancelTokenSourceRef.current = undefined;

      return resp.data.sort((a,b) => a.name.localeCompare(b.name));
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
    'categories',
        //props
  ],
      //([_k, p]) => fetcher(p),
    ([_k]) => fetcher(),
    {
      shouldRetryOnError: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval:1
    }
  );
};


export default useCategories;

